var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnSoundOffM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8187 12.3222C15.5679 11.0648 16 9.58449 16 8C16 4.1512 13.4506 0.91699 10 0V1.91451C12.455 2.77453 14.2219 5.1741 14.2219 8C14.2219 9.08541 13.9612 10.1079 13.501 11.0045L14.8187 12.3222ZM13.9252 13.55L12.6472 12.272C11.9391 13.0927 11.0301 13.7246 10 14.0855V16C11.5352 15.592 12.892 14.7254 13.9252 13.55ZM11.0499 10.6746C10.7534 11.0341 10.3984 11.3405 10 11.578V9.62476L11.0499 10.6746ZM8.00065 7.62541V14.8896L3.33398 10.7595V10.7583H0V5.25145H3.3354L4.55092 4.17568L8.00065 7.62541ZM10 7.50344L11.7993 9.30279C11.9313 8.89289 12.0028 8.45446 12.0028 7.99879C12.0028 6.46887 11.1972 5.13324 10 4.41954V7.50344ZM8.00065 5.50409L5.67627 3.17972L8.00065 1.12258V5.50409Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.753906,
    width: 19.9923,
    height: 1.5,
    transform: "rotate(45 1.25 0.753906)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSoundOffM);
export default __webpack_public_path__ + "static/media/btn_sound_off_m.46414675cec18fe4d8750939e2ea223e.svg";
export { ForwardRef as ReactComponent };